import React, { useEffect, useState } from "react";
import "./PageView.scss";
import Constants from "@/constants";
import { createWithQueryHOC } from "@/components/WithQuery";
import { useMainPanel, useListenMainPanelEvent } from "@/hooks/service";
import logger from "@/utils/logger";
import { usePullToRefresh } from "@/hooks";

const ComponentPage = React.lazy(() => import("./ComponentPage"));
const MapToolPage = React.lazy(() => import("./MapToolPage"));

interface IPageViewProps {
  data?: any;
}
const PageView: React.FC<IPageViewProps> = props => {
  const [data, setData] = useState(props.data);

  useEffect(() => {
    setData(props.data);
  }, [props.data]);

  useListenMainPanelEvent(data => {
    setData(data);
  });

  useEffect(() => {
    logger.log("getLuckyBagPanel data", data);
  }, [data]);

  usePullToRefresh(() => {
    console.log("🔥下拉刷新触发");
  });

  // 开发环境默认渲染地图工具页；URL 带 ?comp=1 时切换到组件 playground
  const showComponentPage =
    Constants.IS_DEV &&
    new URLSearchParams(window.location.search).get("comp") === "1";
  if (showComponentPage) return <ComponentPage></ComponentPage>;

  return <MapToolPage></MapToolPage>;
};

export default createWithQueryHOC({
  comName: "PageView",
  Com: PageView,
  useQueryHook: useMainPanel,
});
